export const validatedIfIsFilled = (e: Record<string, string>) => {
  return Object.values(e).every((val) => val?.length > 0)
}
